<template>
  <apexchart
    title="device_chart_base"
    :key="refresh_key"
    :series="values_base"
    :options="options_base"
  />
  <apexchart
    :key="refresh_key"
    v-if="store_chart.dates.comp"
    title="device_chart_comp"
    :series="values_comp"
    :options="options_comp"
  />
</template>

<script setup lang="ts">
import { useChartStore } from '@/stores/store_chart'
import { useEventBus } from '@vueuse/core'
import { ref } from 'vue'

const bus = useEventBus('chart_fetch')
const refresh_key = ref(0)
const store_chart = useChartStore()
const values_base = ref<any[]>([])
const values_comp = ref<any[]>([])
const options_base = ref({
  chart: { id: 'base', height: 400, type: 'bar', stacked: true },
  datalabels: {
    enable: true
  },
  yaxis: {
    labels: {
      formatter: (v: number | undefined) => {
        if (v == undefined) return '-'
        return Number(v).toFixed(2) + 't'
      }
    },
    title: {
      text: 'Tonnes (t)',
      style: {
        fontSize: '14px',
        fontWeight: 'bold'
      }
    }
  },
  xaxis: {
    categories: store_chart.getMonths('base'),
    tickAmount: store_chart.getMonths('base').length
  },
  title: { text: store_chart.getDevice?.name },
  tooltip: {
    x: {
      show: true
    }
  }
})

const options_comp = ref({
  chart: { id: 'base', height: 400, type: 'bar', stacked: true },
  yaxis: store_chart.getAxis('base'),
  xaxis: {
    categories: store_chart.getMonths('comp'),
    tickAmount: store_chart.getMonths('comp').length
  },
  title: { text: store_chart.getDevice?.name },
  tooltip: {
    x: {
      show: true
    }
  }
})

bus.on(() => {
  const months_base = store_chart.getMonths('base')
  const series_base = store_chart.getSeries('base')
  options_base.value.xaxis.categories = months_base
  options_base.value.xaxis.tickAmount = months_base.length - 1

  const months_comp = store_chart.getMonths('comp')
  const series_comp = store_chart.getSeries('comp')
  options_comp.value.xaxis.categories = months_comp
  options_comp.value.xaxis.tickAmount = months_comp.length - 1

  const data_base = []
  for (const serie of series_base) {
    const copy = { ...serie }
    copy.type = 'bar'
    copy.name = serie.name
    copy.data = Object.values(
      copy.data.reduce<Record<number, number>>((acc, e: any) => {
        acc[e.x] = (acc[e.x] || 0) + e.y
        return acc
      }, {})
    )

    data_base.push(copy)
  }
  values_base.value = data_base

  const data_comp = []
  for (const serie of series_comp) {
    const copy = { ...serie }
    copy.type = 'bar'
    copy.name = serie.name
    copy.data = Object.values(
      copy.data.reduce<Record<number, number>>((acc, e: any) => {
        acc[e.x] = (acc[e.x] || 0) + e.y
        return acc
      }, {})
    )

    data_comp.push(copy)
  }

  values_comp.value = data_comp

  refresh_key.value++
})
</script>
